import styled from "styled-components";
import { CommonRechargeCard } from "../../atom";

export const PictureGiftMemberWrapper = styled.div`
  .rule-text {
    position: absolute;
    right: 0;
    top: -48px;
  }
`;

export const PictureGiftMemberRechargeCard = styled(CommonRechargeCard)`
  .recharge-vip {
    color: #ffffff;
    font-size: 14px;
    line-height: 18px;
  }
  .tip-text {
    margin-bottom: 4px !important;
  }
`;
export const RechargePerMonth = styled.div`
  font-size: 14px;
  color: #ffffff;
  line-height: 17px;
  margin-top: 15px;
`;
